import { type RouteRecordRaw } from 'vue-router'

export const OrphanedRouter: RouteRecordRaw[] = [
  {
    path: '/orphaned',
    component: async () => import('./Orphaned.vue'),
  },
]
